import * as React from "react";
import { connect } from "react-redux";
import { BetLevel } from "../../../../v2/components/BetLevel";
import { AutoplaySettingsMobile } from "../../AutoplaySettings";
import { HeaderMobile } from "../../Header";
import { KeypadMobile } from "../../Keypad";
import { MenuMobile } from "../../Menu";
import { TickerDisplayMobile } from "../../TickerDisplay";
import { TopBarContainer } from "../../TopBar/TopBar";
import { DisplayMode } from "../../../../api/api";

export const View = ({ displayMode }) => (
  <>
    {(displayMode === DisplayMode.DEFAULT ||
      displayMode === DisplayMode.MINIMAL) && (
      <>
        <TickerDisplayMobile />
        <HeaderMobile />
        <MenuMobile />
        <BetLevel />
        <AutoplaySettingsMobile />
        <KeypadMobile />
      </>
    )}
    {displayMode === DisplayMode.TOPBAR && <TopBarContainer />}
  </>
);

const mapPropsToState = ({ displayMode }) => ({ displayMode });

export const DisplayModeSwitcher = connect(mapPropsToState)(View);
